import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../Layout/Main/header/Header";
import Footer from "../../../Layout/Main/footer/FooterTwo";
const Content = [
{
    subTitle: 'Make a checklist of your items',
    Content: 'First, make a checklist of what household items you required. Everyone"s list is different because it all depends on how much time do you have. Some people have two months for packing while some have only two weeks. So, arrange your checklist accordingly.',
    id: 1
},
{
    subTitle: 'Categorize so you can pick less',
    Content: 'A crucial packing tip is to make a list of things you do not need. You can lighten your stress and workload by sell or donate all the stuff you no longer need. Measure the new place where you are going and get rid of all furniture that will not fit in your new location.',
    id: 2
},
{
    subTitle: 'Purchase some quality moving boxes',
    Content: 'If you want to put heavy things in boxes, then buy boxes of good quality, so they do not fall apart in your hands while you are trying to move it into other places. Grocery boxes or reused boxes can be compromised due to moisture.',
    id: 3
},
{
    subTitle: 'First pack essential things',
    Content: 'When you are moving to a new place first pack the things which you needed most, because all the boxes contain the same color, so you do not mix the essential stuff.',
    id: 4
},
{
    subTitle: 'Use the color packing label.',
    Content: 'To stay organized, use the color label and put it on boxes. This moving tip can save your ton of time. You do not have to get panic for finding the important material. ',
    id: 5
},
{
    subTitle: 'Do not overload your moving box',
    Content: 'A lot of people made a massive mistake while moving; they cram all their belongings in a few boxes and overload them. As a result, the box itself unbox in your hand. Use as many boxes as you need to create easy-to-lift loads. Try to keep your most jumbo boxes to not more than fifty pounds.',
    id: 6
},
{
    subTitle: 'Use the right box for the right material',
    Content: 'Put heavy material like books in small boxes and light things in large boxes to make it easier for the mover to organize and pack all boxes in the moving truck. Make sure to put heavier items on the bottom and the lighter one on the top to avoid damaging the fragile items.',
    id: 7
},
{
    subTitle: 'Fill all the spaces in the box',
    Content: 'After putting all the material in the box, if the small spaces left then, fill that spaces with packing paper, clothing or form, peanuts, etc. Use tape at the bottom and top of the box. You can also use tape in places where stress is concentrated.',
    id: 8
},


];
class Tips extends Component{
    render(){
        let title = 'Moving Guide for Every First-Time Mover';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Furniture Assembly' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Moving Guide'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-8 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title text-left">{title}</h2>
                                            <p className="description text-left pt--50">Are you faced with your first relocation? Then it’s not a surprise that you’re so confused and you have no idea what to do. Don’t worry because this simple moving guide is all you need to deal successfully with your removals.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Make a plan</h3>
                                            <p className="description text-left pt--50">It’s not a good idea to start packing your belongings if you haven’t organized your move. Making a plan is the first thing that would help you deal with problems and make sure that your relocation will pass smoothly. All experts from moving company Victoria recommend writing on a piece of paper all your tasks and making a schedule who should take care of them and, of course, when. Hang it on the fridge or somewhere else where everyone could see it and make sure that all members of your family are familiar with it.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Find assistants or Hire a moving company</h3>
                                            <p className="description text-left pt--50">There is no doubt that someone should give you a hand, but who will be this person? Will you hire a professional moving company, or you’ll try to cope alone? The choice is yours! But no matter what you’ll decide, bear in mind that you have to discover your helpers well in advance.</p>
                                        </div>
                                        
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Make some decisions</h3>
                                            <p className="description text-left pt--50">Even if you’ve made up your mind whether you’ll take advantage of professional <b>moving services Victoria</b> or you’ll manage alone, this is not all that requires your attention. You have to choose a date for your relocation, services that you’ll use and so on. There are many details that you have to take care of before packing suitcases and leaving your old home.
When you pass through these steps successfully, you could be sure that you’re ready to move to your new property.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Pack your belongings</h3>
                                            <p className="description text-left pt--50">If you are going to move for the first time, follow these tips for packing your belongings. First, before packing your things, you have to make sure you have an excess number of boxes. You will never know if you need another box to store other items that you may have overlooked. Then you should assign a place in your house where you will organize your things. You may call it the Packing Headquarters, where all the packing necessities like boxes, scissors, tapes, and markers are stored. </p>
                                            <p className="description text-left pt--10">Always put the heaviest or strongest item on the bottom. The more fragile items should be on top. Label the box “fragile,” so your moving company can segregate it from other boxes. Never place too many heavy things in the same box. Heavy boxes would more likely cause a breakage of the items inside it. Place your important items like jewelry, cash, and other essential elements in one folder or bag. This way, you can always have your essentials within arms’ reach. </p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Pack your plants</h3>
                                            <p className="description text-left pt--50">Wrap your plants in some bubble wrap, but don’t forget to leave some holes that will let your plants breathe. All professional movers in Victoria would advise you to be extremely careful when you’re arranging plants in your car. They must be placed on the floor, and you must make sure that they’re steady and won’t fall down. Take care well of your plants, and they’ll beautify your new home too.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Moving with birds:</h3>
                                            <p className="description text-left pt--50">How well will the move proceed depends mostly on how much your pet is used to the surrounding area, especially when your pet happens to be a bird. Very often changing, it brings only stress and unsureness. Unlike the furniture which will most likely be handled by moving services, it’s best to carry the bird by car. This way, the transition will go nice and easy.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Moving with Your Pets</h3>
                                            <p className="description text-left pt--50">If you have pets, you have one more issue to consider when moving. It can be very challenging for first-time movers. It’s advisable to think about it way prior to the date of the actual moving, for there are several things to be considered in order to minimize the risks of your petting catching a cold or simply stressing out from the procedure. There are several precautions to be taken for your pet’s sake which include:</p>
                                            <ul style={{fontSize:'20px',textAlign: '-webkit-left'}}>
                                                <li>Watching your pet’s feeding schedule before the moving – if the trip is long; you might choose not to give him food in the few hours prior to the departure. However, this shouldn’t eliminate the need to stop regularly on the road in order to make quick walks on the outside;</li>
                                                <li>do not leave your pet alone in the car;</li>
                                                <li>place an identification tag on your pet’s collar – it the chaos during the moving in Victoria your pet may get nervous and try to escape, you wouldn’t want to lose it, so carefully attach a telephone number at least to his leash. Finally, do not forget to prepare a small bag with the most necessary things for your pet: medications, food, water, tissues, a favorite small toy, and a blanket. Make sure your pet feels comfortable on the road so that you are at ease as well.</li>
                                            </ul>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Moving with Children</h3>
                                            <p className="description text-left pt--50">If you are moving for the first time, you could never be absolutely prepared for such a challenge. Here are some tips that could ease your relocation a lot. </p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Why, when and what</h3>
                                            <p className="description text-left pt--50">Your kids will wonder why you’ll have to change your home and what will happen after that. Probably they’ll be very confused and alarmed. On top of all, they’ll have to overcome the stress of leaving their friends. The best way to help them manage this situation is to explain to them why you’ll have to move out. Spend some time and tell your kids where you will live. It’ll be even better if you show them their new home before hiring Vancouver movers.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left"> Involve them in the moving process</h3>
                                            <p className="description text-left pt--50">That will keep them busy, and they’ll be able to get used to the new environment easily. They can give you a hand with packing, of course, unless you’ve decided to take advantage of professional moving services in Victoria like Moonline Moving.
The most difficult part of moving with kids is to convince them that this isn’t just a passing whim, but you really have to go. If you succeed in coping with that, your relocation will be as easy as pie.</p>
                                            <p className="description text-left pt--10">If you are a first-time mover and want to book your move or moving free quote, contact us today for a free quote and get information about your move.</p>
                                        </div>
                                       
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Tips;